import { useLocation, useNavigate } from 'react-router-dom';
import ParkingCheckoutLayout from '../../components/checkout/ParkingCheckoutLayout';

function formatDurationHrs(hrs) {
    if (!hrs || hrs <= 0) return '';
    const days = Math.floor(hrs / 24);
    const rem = hrs % 24;
    return days > 0 ? `${days}d ${rem}h` : `${hrs}h`;
}

function formatDateTime(date, time) {
    if (!date) return '—';
    const d = new Date(`${date}T${time || '00:00'}`);
    return d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' })
        + (time ? ` ${d.toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit' })}` : '');
}

export default function OffstreetParkingCheckout() {
    const location = useLocation();
    const navigate = useNavigate();
    const paymentSession = location.state?.paymentSession;
    const bookingData = location.state?.bookingData;

    if (!paymentSession && !bookingData) {
        return (
            <div className="text-center py-8">
                <p className="text-red-600 mb-4">Booking not found. Please go back and try again.</p>
                <button onClick={() => navigate('/shoppingcart')} className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg">Back to Cart</button>
            </div>
        );
    }

    const { arrivalDate, arrivalTime, departureDate, departureTime, durationHrs, hourlyRate, total, currency } = bookingData || {};
    const currencySymbol = { USD: '$', AUD: 'A$', GBP: '£', EUR: '€', BRL: 'R$' }[currency] || '$';

    const sidebar = (
        <>
            <h3 className="font-bold text-gray-900 mb-4">Offstreet Parking</h3>
            <div className="space-y-2 mb-4">
                <div className="flex justify-between text-sm">
                    <span className="text-gray-500">Entry</span>
                    <span className="text-gray-900 font-medium">{formatDateTime(arrivalDate, arrivalTime)}</span>
                </div>
                <div className="flex justify-between text-sm">
                    <span className="text-gray-500">Exit</span>
                    <span className="text-gray-900 font-medium">{formatDateTime(departureDate, departureTime)}</span>
                </div>
            </div>
            {durationHrs > 0 && (
                <div className="bg-purple-50 rounded-lg p-3 mb-4">
                    <p className="text-sm text-gray-700">Duration: <span className="font-semibold">{formatDurationHrs(durationHrs)}</span></p>
                    <p className="text-xs text-gray-500">{currencySymbol}{(hourlyRate || 0).toFixed(2)}/hr</p>
                </div>
            )}
            <button onClick={() => navigate('/shoppingcart')} className="text-purple-700 text-sm font-medium hover:underline mb-4 block">
                &#8592; Change booking details
            </button>
        </>
    );

    return (
        <ParkingCheckoutLayout
            paymentSession={paymentSession}
            sidebarContent={sidebar}
            total={total || 0}
            currency={currency}
            containerId="offstreet-hosted-checkout"
            headingText="Parking"
        />
    );
}
